export const previews = [{
  images: [[{
    id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg',
    idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg',
    src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg',
    type: 'Image191x100',
    width: 1080,
    height: 1080,
    cropSettings: {
      SourceX: 0, SourceY: 258, SourceWidth: 1080, SourceHeight: 565,
    },
    isIncluded: true,
    isLogo: false,
    isRecommendedImage: true,
    originCropSetting: {
      SourceWidth: 1080, SourceHeight: 565, SourceX: 0, SourceY: 258,
    },
    baseImage: {
      id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg',
      idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg',
      src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg',
      type: null,
      width: 1080,
      height: 1080,
      cropSettings: null,
      effectSettings: null,
      baseId: null,
      metadata: null,
      isIncluded: true,
      isLogo: false,
      isRecommendedImage: true,
      originCropSetting: {
        SourceWidth: 1080, SourceHeight: 565, SourceX: 0, SourceY: 258,
      },
    },
  }, {
    id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg',
    idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg',
    src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg',
    type: 'Image178x100',
    associationType: 'ImageMedia178X100',
    width: 1080,
    height: 1080,
    cropSettings: {
      SourceWidth: 1080, SourceHeight: 607, SourceX: 0, SourceY: 237,
    },
    isIncluded: true,
    isLogo: false,
    isRecommendedImage: false,
    originCropSetting: {
      SourceWidth: 1080, SourceHeight: 607, SourceX: 0, SourceY: 237,
    },
    isAutoCropping: true,
    baseImage: {
      id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg', idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg', src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg', type: null, associationType: 'ImageMedia178X100', width: 1080, height: 1080, cropSettings: null, effectSettings: null, baseId: null, metadata: null, isIncluded: false, isLogo: false, isRecommendedImage: false, originCropSetting: null,
    },
  }, {
    id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg',
    idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg',
    src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg',
    type: 'Image150x100',
    associationType: 'ImageMedia15X10',
    width: 1080,
    height: 1080,
    cropSettings: {
      SourceWidth: 1080, SourceHeight: 720, SourceX: 0, SourceY: 180,
    },
    isIncluded: true,
    isLogo: false,
    isRecommendedImage: false,
    originCropSetting: {
      SourceWidth: 1080, SourceHeight: 720, SourceX: 0, SourceY: 180,
    },
    isAutoCropping: true,
    baseImage: {
      id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg', idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg', src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg', type: null, associationType: 'ImageMedia15X10', width: 1080, height: 1080, cropSettings: null, effectSettings: null, baseId: null, metadata: null, isIncluded: false, isLogo: false, isRecommendedImage: false, originCropSetting: null,
    },
  }, {
    id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg',
    idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg',
    src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg',
    type: 'Image133x100',
    associationType: 'ImageMedia133X100',
    width: 1080,
    height: 1080,
    cropSettings: {
      SourceWidth: 1080, SourceHeight: 812, SourceX: 0, SourceY: 134,
    },
    isIncluded: true,
    isLogo: false,
    isRecommendedImage: false,
    originCropSetting: {
      SourceWidth: 1080, SourceHeight: 812, SourceX: 0, SourceY: 134,
    },
    isAutoCropping: true,
    baseImage: {
      id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg', idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg', src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg', type: null, associationType: 'ImageMedia133X100', width: 1080, height: 1080, cropSettings: null, effectSettings: null, baseId: null, metadata: null, isIncluded: false, isLogo: false, isRecommendedImage: false, originCropSetting: null,
    },
  }, {
    id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg',
    idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg',
    src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg',
    type: 'Image1x1',
    associationType: 'SquareImageMedia',
    width: 1080,
    height: 1080,
    cropSettings: {
      SourceWidth: 1080, SourceHeight: 1080, SourceX: 0, SourceY: 0,
    },
    isIncluded: true,
    isLogo: false,
    isRecommendedImage: false,
    originCropSetting: {
      SourceWidth: 1080, SourceHeight: 1080, SourceX: 0, SourceY: 0,
    },
    isAutoCropping: true,
    baseImage: {
      id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg', idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg', src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg', type: null, associationType: 'SquareImageMedia', width: 1080, height: 1080, cropSettings: null, effectSettings: null, baseId: null, metadata: null, isIncluded: true, isLogo: false, isRecommendedImage: false, originCropSetting: null,
    },
  }], [{
    id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg',
    idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg',
    src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg',
    type: 'Image191x100',
    width: 1080,
    height: 1080,
    cropSettings: {
      SourceX: 0, SourceY: 258, SourceWidth: 1080, SourceHeight: 565,
    },
    isIncluded: true,
    isLogo: false,
    isRecommendedImage: true,
    originCropSetting: {
      SourceWidth: 1080, SourceHeight: 565, SourceX: 0, SourceY: 258,
    },
    baseImage: {
      id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg',
      idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg',
      src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg',
      type: null,
      width: 1080,
      height: 1080,
      cropSettings: null,
      effectSettings: null,
      baseId: null,
      metadata: null,
      isIncluded: true,
      isLogo: false,
      isRecommendedImage: true,
      originCropSetting: {
        SourceWidth: 1080, SourceHeight: 565, SourceX: 0, SourceY: 258,
      },
    },
  }, {
    id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg',
    idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg',
    src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg',
    type: 'Image178x100',
    associationType: 'ImageMedia178X100',
    width: 1080,
    height: 1080,
    cropSettings: {
      SourceWidth: 1080, SourceHeight: 607, SourceX: 0, SourceY: 237,
    },
    isIncluded: true,
    isLogo: false,
    isRecommendedImage: false,
    originCropSetting: {
      SourceWidth: 1080, SourceHeight: 607, SourceX: 0, SourceY: 237,
    },
    isAutoCropping: true,
    baseImage: {
      id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg', idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg', src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg', type: null, associationType: 'ImageMedia178X100', width: 1080, height: 1080, cropSettings: null, effectSettings: null, baseId: null, metadata: null, isIncluded: false, isLogo: false, isRecommendedImage: false, originCropSetting: null,
    },
  }, {
    id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg',
    idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg',
    src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg',
    type: 'Image150x100',
    associationType: 'ImageMedia15X10',
    width: 1080,
    height: 1080,
    cropSettings: {
      SourceWidth: 1080, SourceHeight: 720, SourceX: 0, SourceY: 180,
    },
    isIncluded: true,
    isLogo: false,
    isRecommendedImage: false,
    originCropSetting: {
      SourceWidth: 1080, SourceHeight: 720, SourceX: 0, SourceY: 180,
    },
    isAutoCropping: true,
    baseImage: {
      id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg', idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg', src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg', type: null, associationType: 'ImageMedia15X10', width: 1080, height: 1080, cropSettings: null, effectSettings: null, baseId: null, metadata: null, isIncluded: false, isLogo: false, isRecommendedImage: false, originCropSetting: null,
    },
  }, {
    id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg',
    idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg',
    src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg',
    type: 'Image133x100',
    associationType: 'ImageMedia133X100',
    width: 1080,
    height: 1080,
    cropSettings: {
      SourceWidth: 1080, SourceHeight: 812, SourceX: 0, SourceY: 134,
    },
    isIncluded: true,
    isLogo: false,
    isRecommendedImage: false,
    originCropSetting: {
      SourceWidth: 1080, SourceHeight: 812, SourceX: 0, SourceY: 134,
    },
    isAutoCropping: true,
    baseImage: {
      id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg', idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg', src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg', type: null, associationType: 'ImageMedia133X100', width: 1080, height: 1080, cropSettings: null, effectSettings: null, baseId: null, metadata: null, isIncluded: false, isLogo: false, isRecommendedImage: false, originCropSetting: null,
    },
  }, {
    id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg',
    idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg',
    src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg',
    type: 'Image1x1',
    associationType: 'SquareImageMedia',
    width: 1080,
    height: 1080,
    cropSettings: {
      SourceWidth: 1080, SourceHeight: 1080, SourceX: 0, SourceY: 0,
    },
    isIncluded: true,
    isLogo: false,
    isRecommendedImage: false,
    originCropSetting: {
      SourceWidth: 1080, SourceHeight: 1080, SourceX: 0, SourceY: 0,
    },
    isAutoCropping: true,
    baseImage: {
      id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg', idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg', src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg', type: null, associationType: 'SquareImageMedia', width: 1080, height: 1080, cropSettings: null, effectSettings: null, baseId: null, metadata: null, isIncluded: true, isLogo: false, isRecommendedImage: false, originCropSetting: null,
    },
  }], [{
    id: 'https://blogs.bing.com/BingBlogs/files/50/50be2ce8-de70-4b33-8aa6-43abf774d114.png',
    idString: 'https://blogs.bing.com/BingBlogs/files/50/50be2ce8-de70-4b33-8aa6-43abf774d114.png',
    src: 'https://blogs.bing.com/BingBlogs/files/50/50be2ce8-de70-4b33-8aa6-43abf774d114.png',
    type: 'Image191x100',
    width: 2400,
    height: 1290,
    cropSettings: {
      SourceX: 0, SourceY: 17, SourceWidth: 2400, SourceHeight: 1257,
    },
    isIncluded: true,
    isLogo: false,
    isRecommendedImage: true,
    originCropSetting: {
      SourceWidth: 2400, SourceHeight: 1257, SourceX: 0, SourceY: 17,
    },
    baseImage: {
      id: 'https://blogs.bing.com/BingBlogs/files/50/50be2ce8-de70-4b33-8aa6-43abf774d114.png',
      idString: 'https://blogs.bing.com/BingBlogs/files/50/50be2ce8-de70-4b33-8aa6-43abf774d114.png',
      src: 'https://blogs.bing.com/BingBlogs/files/50/50be2ce8-de70-4b33-8aa6-43abf774d114.png',
      type: null,
      width: 2400,
      height: 1290,
      cropSettings: null,
      effectSettings: null,
      baseId: null,
      metadata: null,
      isIncluded: true,
      isLogo: false,
      isRecommendedImage: true,
      originCropSetting: {
        SourceWidth: 2400, SourceHeight: 1257, SourceX: 0, SourceY: 17,
      },
    },
  }, {
    id: 'https://blogs.bing.com/BingBlogs/files/50/50be2ce8-de70-4b33-8aa6-43abf774d114.png',
    idString: 'https://blogs.bing.com/BingBlogs/files/50/50be2ce8-de70-4b33-8aa6-43abf774d114.png',
    src: 'https://blogs.bing.com/BingBlogs/files/50/50be2ce8-de70-4b33-8aa6-43abf774d114.png',
    type: 'Image178x100',
    associationType: 'ImageMedia178X100',
    width: 2400,
    height: 1290,
    cropSettings: {
      SourceWidth: 2296, SourceHeight: 1290, SourceX: 52, SourceY: 0,
    },
    isIncluded: true,
    isLogo: false,
    isRecommendedImage: false,
    originCropSetting: {
      SourceWidth: 2296, SourceHeight: 1290, SourceX: 52, SourceY: 0,
    },
    isAutoCropping: true,
    baseImage: {
      id: 'https://blogs.bing.com/BingBlogs/files/50/50be2ce8-de70-4b33-8aa6-43abf774d114.png', idString: 'https://blogs.bing.com/BingBlogs/files/50/50be2ce8-de70-4b33-8aa6-43abf774d114.png', src: 'https://blogs.bing.com/BingBlogs/files/50/50be2ce8-de70-4b33-8aa6-43abf774d114.png', type: null, associationType: 'ImageMedia178X100', width: 2400, height: 1290, cropSettings: null, effectSettings: null, baseId: null, metadata: null, isIncluded: false, isLogo: false, isRecommendedImage: false, originCropSetting: null,
    },
  }, {
    id: 'https://blogs.bing.com/BingBlogs/files/50/50be2ce8-de70-4b33-8aa6-43abf774d114.png',
    idString: 'https://blogs.bing.com/BingBlogs/files/50/50be2ce8-de70-4b33-8aa6-43abf774d114.png',
    src: 'https://blogs.bing.com/BingBlogs/files/50/50be2ce8-de70-4b33-8aa6-43abf774d114.png',
    type: 'Image150x100',
    associationType: 'ImageMedia15X10',
    width: 2400,
    height: 1290,
    cropSettings: {
      SourceWidth: 1935, SourceHeight: 1290, SourceX: 233, SourceY: 0,
    },
    isIncluded: true,
    isLogo: false,
    isRecommendedImage: false,
    originCropSetting: {
      SourceWidth: 1935, SourceHeight: 1290, SourceX: 233, SourceY: 0,
    },
    isAutoCropping: true,
    baseImage: {
      id: 'https://blogs.bing.com/BingBlogs/files/50/50be2ce8-de70-4b33-8aa6-43abf774d114.png', idString: 'https://blogs.bing.com/BingBlogs/files/50/50be2ce8-de70-4b33-8aa6-43abf774d114.png', src: 'https://blogs.bing.com/BingBlogs/files/50/50be2ce8-de70-4b33-8aa6-43abf774d114.png', type: null, associationType: 'ImageMedia15X10', width: 2400, height: 1290, cropSettings: null, effectSettings: null, baseId: null, metadata: null, isIncluded: false, isLogo: false, isRecommendedImage: false, originCropSetting: null,
    },
  }, {
    id: 'https://blogs.bing.com/BingBlogs/files/50/50be2ce8-de70-4b33-8aa6-43abf774d114.png',
    idString: 'https://blogs.bing.com/BingBlogs/files/50/50be2ce8-de70-4b33-8aa6-43abf774d114.png',
    src: 'https://blogs.bing.com/BingBlogs/files/50/50be2ce8-de70-4b33-8aa6-43abf774d114.png',
    type: 'Image133x100',
    associationType: 'ImageMedia133X100',
    width: 2400,
    height: 1290,
    cropSettings: {
      SourceWidth: 1716, SourceHeight: 1290, SourceX: 342, SourceY: 0,
    },
    isIncluded: true,
    isLogo: false,
    isRecommendedImage: false,
    originCropSetting: {
      SourceWidth: 1716, SourceHeight: 1290, SourceX: 342, SourceY: 0,
    },
    isAutoCropping: true,
    baseImage: {
      id: 'https://blogs.bing.com/BingBlogs/files/50/50be2ce8-de70-4b33-8aa6-43abf774d114.png', idString: 'https://blogs.bing.com/BingBlogs/files/50/50be2ce8-de70-4b33-8aa6-43abf774d114.png', src: 'https://blogs.bing.com/BingBlogs/files/50/50be2ce8-de70-4b33-8aa6-43abf774d114.png', type: null, associationType: 'ImageMedia133X100', width: 2400, height: 1290, cropSettings: null, effectSettings: null, baseId: null, metadata: null, isIncluded: false, isLogo: false, isRecommendedImage: false, originCropSetting: null,
    },
  }, {
    id: 'https://blogs.bing.com/BingBlogs/files/50/50be2ce8-de70-4b33-8aa6-43abf774d114.png',
    idString: 'https://blogs.bing.com/BingBlogs/files/50/50be2ce8-de70-4b33-8aa6-43abf774d114.png',
    src: 'https://blogs.bing.com/BingBlogs/files/50/50be2ce8-de70-4b33-8aa6-43abf774d114.png',
    type: 'Image1x1',
    associationType: 'SquareImageMedia',
    width: 2400,
    height: 1290,
    cropSettings: {
      SourceWidth: 1290, SourceHeight: 1290, SourceX: 555, SourceY: 0,
    },
    isIncluded: true,
    isLogo: false,
    isRecommendedImage: false,
    originCropSetting: {
      SourceWidth: 1290, SourceHeight: 1290, SourceX: 555, SourceY: 0,
    },
    isAutoCropping: true,
    baseImage: {
      id: 'https://blogs.bing.com/BingBlogs/files/50/50be2ce8-de70-4b33-8aa6-43abf774d114.png', idString: 'https://blogs.bing.com/BingBlogs/files/50/50be2ce8-de70-4b33-8aa6-43abf774d114.png', src: 'https://blogs.bing.com/BingBlogs/files/50/50be2ce8-de70-4b33-8aa6-43abf774d114.png', type: null, associationType: 'SquareImageMedia', width: 2400, height: 1290, cropSettings: null, effectSettings: null, baseId: null, metadata: null, isIncluded: false, isLogo: false, isRecommendedImage: false, originCropSetting: null,
    },
  }]],
  shortHeadline: 'Maps Bing Maps',
  longHeadline: 'Make it faster and easier to go from Browsing to doing Things Online.',
  description: 'Make it faster and easier to go from Browsing to doing Things Online.',
  businessName: 'Bing',
  url: 'https://bing.com',
}, {
  images: [[{
    id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg',
    idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg',
    src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg',
    type: 'Image191x100',
    width: 1080,
    height: 1080,
    cropSettings: {
      SourceX: 0, SourceY: 258, SourceWidth: 1080, SourceHeight: 565,
    },
    isIncluded: true,
    isLogo: false,
    isRecommendedImage: true,
    originCropSetting: {
      SourceWidth: 1080, SourceHeight: 565, SourceX: 0, SourceY: 258,
    },
    baseImage: {
      id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg',
      idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg',
      src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg',
      type: null,
      width: 1080,
      height: 1080,
      cropSettings: null,
      effectSettings: null,
      baseId: null,
      metadata: null,
      isIncluded: true,
      isLogo: false,
      isRecommendedImage: true,
      originCropSetting: {
        SourceWidth: 1080, SourceHeight: 565, SourceX: 0, SourceY: 258,
      },
    },
  }, {
    id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg',
    idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg',
    src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg',
    type: 'Image178x100',
    associationType: 'ImageMedia178X100',
    width: 1080,
    height: 1080,
    cropSettings: {
      SourceWidth: 1080, SourceHeight: 607, SourceX: 0, SourceY: 237,
    },
    isIncluded: true,
    isLogo: false,
    isRecommendedImage: false,
    originCropSetting: {
      SourceWidth: 1080, SourceHeight: 607, SourceX: 0, SourceY: 237,
    },
    isAutoCropping: true,
    baseImage: {
      id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg', idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg', src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg', type: null, associationType: 'ImageMedia178X100', width: 1080, height: 1080, cropSettings: null, effectSettings: null, baseId: null, metadata: null, isIncluded: false, isLogo: false, isRecommendedImage: false, originCropSetting: null,
    },
  }, {
    id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg',
    idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg',
    src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg',
    type: 'Image150x100',
    associationType: 'ImageMedia15X10',
    width: 1080,
    height: 1080,
    cropSettings: {
      SourceWidth: 1080, SourceHeight: 720, SourceX: 0, SourceY: 180,
    },
    isIncluded: true,
    isLogo: false,
    isRecommendedImage: false,
    originCropSetting: {
      SourceWidth: 1080, SourceHeight: 720, SourceX: 0, SourceY: 180,
    },
    isAutoCropping: true,
    baseImage: {
      id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg', idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg', src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg', type: null, associationType: 'ImageMedia15X10', width: 1080, height: 1080, cropSettings: null, effectSettings: null, baseId: null, metadata: null, isIncluded: false, isLogo: false, isRecommendedImage: false, originCropSetting: null,
    },
  }, {
    id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg',
    idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg',
    src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg',
    type: 'Image133x100',
    associationType: 'ImageMedia133X100',
    width: 1080,
    height: 1080,
    cropSettings: {
      SourceWidth: 1080, SourceHeight: 812, SourceX: 0, SourceY: 134,
    },
    isIncluded: true,
    isLogo: false,
    isRecommendedImage: false,
    originCropSetting: {
      SourceWidth: 1080, SourceHeight: 812, SourceX: 0, SourceY: 134,
    },
    isAutoCropping: true,
    baseImage: {
      id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg', idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg', src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg', type: null, associationType: 'ImageMedia133X100', width: 1080, height: 1080, cropSettings: null, effectSettings: null, baseId: null, metadata: null, isIncluded: false, isLogo: false, isRecommendedImage: false, originCropSetting: null,
    },
  }, {
    id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg',
    idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg',
    src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg',
    type: 'Image1x1',
    associationType: 'SquareImageMedia',
    width: 1080,
    height: 1080,
    cropSettings: {
      SourceWidth: 1080, SourceHeight: 1080, SourceX: 0, SourceY: 0,
    },
    isIncluded: true,
    isLogo: false,
    isRecommendedImage: false,
    originCropSetting: {
      SourceWidth: 1080, SourceHeight: 1080, SourceX: 0, SourceY: 0,
    },
    isAutoCropping: true,
    baseImage: {
      id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg', idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg', src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg', type: null, associationType: 'SquareImageMedia', width: 1080, height: 1080, cropSettings: null, effectSettings: null, baseId: null, metadata: null, isIncluded: true, isLogo: false, isRecommendedImage: false, originCropSetting: null,
    },
  }], [{
    id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg',
    idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg',
    src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg',
    type: 'Image191x100',
    width: 1080,
    height: 1080,
    cropSettings: {
      SourceX: 0, SourceY: 258, SourceWidth: 1080, SourceHeight: 565,
    },
    isIncluded: true,
    isLogo: false,
    isRecommendedImage: true,
    originCropSetting: {
      SourceWidth: 1080, SourceHeight: 565, SourceX: 0, SourceY: 258,
    },
    baseImage: {
      id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg',
      idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg',
      src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg',
      type: null,
      width: 1080,
      height: 1080,
      cropSettings: null,
      effectSettings: null,
      baseId: null,
      metadata: null,
      isIncluded: true,
      isLogo: false,
      isRecommendedImage: true,
      originCropSetting: {
        SourceWidth: 1080, SourceHeight: 565, SourceX: 0, SourceY: 258,
      },
    },
  }, {
    id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg',
    idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg',
    src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg',
    type: 'Image178x100',
    associationType: 'ImageMedia178X100',
    width: 1080,
    height: 1080,
    cropSettings: {
      SourceWidth: 1080, SourceHeight: 607, SourceX: 0, SourceY: 237,
    },
    isIncluded: true,
    isLogo: false,
    isRecommendedImage: false,
    originCropSetting: {
      SourceWidth: 1080, SourceHeight: 607, SourceX: 0, SourceY: 237,
    },
    isAutoCropping: true,
    baseImage: {
      id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg', idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg', src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg', type: null, associationType: 'ImageMedia178X100', width: 1080, height: 1080, cropSettings: null, effectSettings: null, baseId: null, metadata: null, isIncluded: false, isLogo: false, isRecommendedImage: false, originCropSetting: null,
    },
  }, {
    id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg',
    idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg',
    src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg',
    type: 'Image150x100',
    associationType: 'ImageMedia15X10',
    width: 1080,
    height: 1080,
    cropSettings: {
      SourceWidth: 1080, SourceHeight: 720, SourceX: 0, SourceY: 180,
    },
    isIncluded: true,
    isLogo: false,
    isRecommendedImage: false,
    originCropSetting: {
      SourceWidth: 1080, SourceHeight: 720, SourceX: 0, SourceY: 180,
    },
    isAutoCropping: true,
    baseImage: {
      id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg', idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg', src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg', type: null, associationType: 'ImageMedia15X10', width: 1080, height: 1080, cropSettings: null, effectSettings: null, baseId: null, metadata: null, isIncluded: false, isLogo: false, isRecommendedImage: false, originCropSetting: null,
    },
  }, {
    id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg',
    idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg',
    src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg',
    type: 'Image133x100',
    associationType: 'ImageMedia133X100',
    width: 1080,
    height: 1080,
    cropSettings: {
      SourceWidth: 1080, SourceHeight: 812, SourceX: 0, SourceY: 134,
    },
    isIncluded: true,
    isLogo: false,
    isRecommendedImage: false,
    originCropSetting: {
      SourceWidth: 1080, SourceHeight: 812, SourceX: 0, SourceY: 134,
    },
    isAutoCropping: true,
    baseImage: {
      id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg', idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg', src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg', type: null, associationType: 'ImageMedia133X100', width: 1080, height: 1080, cropSettings: null, effectSettings: null, baseId: null, metadata: null, isIncluded: false, isLogo: false, isRecommendedImage: false, originCropSetting: null,
    },
  }, {
    id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg',
    idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg',
    src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg',
    type: 'Image1x1',
    associationType: 'SquareImageMedia',
    width: 1080,
    height: 1080,
    cropSettings: {
      SourceWidth: 1080, SourceHeight: 1080, SourceX: 0, SourceY: 0,
    },
    isIncluded: true,
    isLogo: false,
    isRecommendedImage: false,
    originCropSetting: {
      SourceWidth: 1080, SourceHeight: 1080, SourceX: 0, SourceY: 0,
    },
    isAutoCropping: true,
    baseImage: {
      id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg', idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg', src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg', type: null, associationType: 'SquareImageMedia', width: 1080, height: 1080, cropSettings: null, effectSettings: null, baseId: null, metadata: null, isIncluded: true, isLogo: false, isRecommendedImage: false, originCropSetting: null,
    },
  }], [{
    id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1A9HiRm2AhPL6u0sgct0ku6nxDSPoHZhb.jpg',
    idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1A9HiRm2AhPL6u0sgct0ku6nxDSPoHZhb.jpg',
    src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1A9HiRm2AhPL6u0sgct0ku6nxDSPoHZhb.jpg',
    type: 'Image191x100',
    width: 1080,
    height: 1080,
    cropSettings: {
      SourceX: 0, SourceY: 258, SourceWidth: 1080, SourceHeight: 565,
    },
    isIncluded: true,
    isLogo: false,
    isRecommendedImage: true,
    originCropSetting: {
      SourceWidth: 1080, SourceHeight: 565, SourceX: 0, SourceY: 258,
    },
    baseImage: {
      id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1A9HiRm2AhPL6u0sgct0ku6nxDSPoHZhb.jpg',
      idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1A9HiRm2AhPL6u0sgct0ku6nxDSPoHZhb.jpg',
      src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1A9HiRm2AhPL6u0sgct0ku6nxDSPoHZhb.jpg',
      type: null,
      width: 1080,
      height: 1080,
      cropSettings: null,
      effectSettings: null,
      baseId: null,
      metadata: null,
      isIncluded: true,
      isLogo: false,
      isRecommendedImage: true,
      originCropSetting: {
        SourceWidth: 1080, SourceHeight: 565, SourceX: 0, SourceY: 258,
      },
    },
  }, {
    id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1A9HiRm2AhPL6u0sgct0ku6nxDSPoHZhb.jpg',
    idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1A9HiRm2AhPL6u0sgct0ku6nxDSPoHZhb.jpg',
    src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1A9HiRm2AhPL6u0sgct0ku6nxDSPoHZhb.jpg',
    type: 'Image178x100',
    associationType: 'ImageMedia178X100',
    width: 1080,
    height: 1080,
    cropSettings: {
      SourceWidth: 1080, SourceHeight: 607, SourceX: 0, SourceY: 237,
    },
    isIncluded: true,
    isLogo: false,
    isRecommendedImage: false,
    originCropSetting: {
      SourceWidth: 1080, SourceHeight: 607, SourceX: 0, SourceY: 237,
    },
    isAutoCropping: true,
    baseImage: {
      id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1A9HiRm2AhPL6u0sgct0ku6nxDSPoHZhb.jpg', idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1A9HiRm2AhPL6u0sgct0ku6nxDSPoHZhb.jpg', src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1A9HiRm2AhPL6u0sgct0ku6nxDSPoHZhb.jpg', type: null, associationType: 'ImageMedia178X100', width: 1080, height: 1080, cropSettings: null, effectSettings: null, baseId: null, metadata: null, isIncluded: false, isLogo: false, isRecommendedImage: false, originCropSetting: null,
    },
  }, {
    id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1A9HiRm2AhPL6u0sgct0ku6nxDSPoHZhb.jpg',
    idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1A9HiRm2AhPL6u0sgct0ku6nxDSPoHZhb.jpg',
    src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1A9HiRm2AhPL6u0sgct0ku6nxDSPoHZhb.jpg',
    type: 'Image150x100',
    associationType: 'ImageMedia15X10',
    width: 1080,
    height: 1080,
    cropSettings: {
      SourceWidth: 1080, SourceHeight: 720, SourceX: 0, SourceY: 180,
    },
    isIncluded: true,
    isLogo: false,
    isRecommendedImage: false,
    originCropSetting: {
      SourceWidth: 1080, SourceHeight: 720, SourceX: 0, SourceY: 180,
    },
    isAutoCropping: true,
    baseImage: {
      id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1A9HiRm2AhPL6u0sgct0ku6nxDSPoHZhb.jpg', idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1A9HiRm2AhPL6u0sgct0ku6nxDSPoHZhb.jpg', src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1A9HiRm2AhPL6u0sgct0ku6nxDSPoHZhb.jpg', type: null, associationType: 'ImageMedia15X10', width: 1080, height: 1080, cropSettings: null, effectSettings: null, baseId: null, metadata: null, isIncluded: false, isLogo: false, isRecommendedImage: false, originCropSetting: null,
    },
  }, {
    id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1A9HiRm2AhPL6u0sgct0ku6nxDSPoHZhb.jpg',
    idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1A9HiRm2AhPL6u0sgct0ku6nxDSPoHZhb.jpg',
    src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1A9HiRm2AhPL6u0sgct0ku6nxDSPoHZhb.jpg',
    type: 'Image133x100',
    associationType: 'ImageMedia133X100',
    width: 1080,
    height: 1080,
    cropSettings: {
      SourceWidth: 1080, SourceHeight: 812, SourceX: 0, SourceY: 134,
    },
    isIncluded: true,
    isLogo: false,
    isRecommendedImage: false,
    originCropSetting: {
      SourceWidth: 1080, SourceHeight: 812, SourceX: 0, SourceY: 134,
    },
    isAutoCropping: true,
    baseImage: {
      id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1A9HiRm2AhPL6u0sgct0ku6nxDSPoHZhb.jpg', idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1A9HiRm2AhPL6u0sgct0ku6nxDSPoHZhb.jpg', src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1A9HiRm2AhPL6u0sgct0ku6nxDSPoHZhb.jpg', type: null, associationType: 'ImageMedia133X100', width: 1080, height: 1080, cropSettings: null, effectSettings: null, baseId: null, metadata: null, isIncluded: false, isLogo: false, isRecommendedImage: false, originCropSetting: null,
    },
  }, {
    id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1A9HiRm2AhPL6u0sgct0ku6nxDSPoHZhb.jpg',
    idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1A9HiRm2AhPL6u0sgct0ku6nxDSPoHZhb.jpg',
    src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1A9HiRm2AhPL6u0sgct0ku6nxDSPoHZhb.jpg',
    type: 'Image1x1',
    associationType: 'SquareImageMedia',
    width: 1080,
    height: 1080,
    cropSettings: {
      SourceWidth: 1080, SourceHeight: 1080, SourceX: 0, SourceY: 0,
    },
    isIncluded: true,
    isLogo: false,
    isRecommendedImage: false,
    originCropSetting: {
      SourceWidth: 1080, SourceHeight: 1080, SourceX: 0, SourceY: 0,
    },
    isAutoCropping: true,
    baseImage: {
      id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1A9HiRm2AhPL6u0sgct0ku6nxDSPoHZhb.jpg', idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1A9HiRm2AhPL6u0sgct0ku6nxDSPoHZhb.jpg', src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1A9HiRm2AhPL6u0sgct0ku6nxDSPoHZhb.jpg', type: null, associationType: 'SquareImageMedia', width: 1080, height: 1080, cropSettings: null, effectSettings: null, baseId: null, metadata: null, isIncluded: true, isLogo: false, isRecommendedImage: false, originCropSetting: null,
    },
  }]],
  shortHeadline: 'Bing Photo Search',
  longHeadline: 'Make it faster and easier to go from Browsing to doing the Things you Love.',
  description: 'Make it faster and easier to go from Browsing to doing the Things you Love.',
  businessName: 'Bing',
  url: 'https://bing.com',
}, {
  images: [[{
    id: '7146826138370',
    idString: '7146826138370',
    src: 'https://www.bing-exp.com/th?id=OADD2.7146826138370_17CZ8MCZKY4MKLZWVI&pid=21.2',
    type: 'Image191x100',
    associationType: 'LandscapeImageMedia',
    width: 1080,
    height: 1080,
    cropSettings: {
      SourceWidth: 1080, SourceHeight: 565, SourceX: 0, SourceY: 258,
    },
    isIncluded: false,
    isLogo: false,
    isRecommendedImage: false,
    originCropSetting: {
      SourceWidth: 1080, SourceHeight: 565, SourceX: 0, SourceY: 258,
    },
    isAutoCropping: true,
    baseImage: {
      id: '7146826138370', idString: '7146826138370', src: 'https://www.bing-exp.com/th?id=OADD2.7146826138370_17CZ8MCZKY4MKLZWVI&pid=21.2', type: null, associationType: 'LandscapeImageMedia', width: 1080, height: 1080, cropSettings: null, effectSettings: null, baseId: null, metadata: null, isIncluded: false, isLogo: false, isRecommendedImage: false, originCropSetting: null,
    },
  }, {
    id: '7146826138370',
    idString: '7146826138370',
    src: 'https://www.bing-exp.com/th?id=OADD2.7146826138370_17CZ8MCZKY4MKLZWVI&pid=21.2',
    type: 'Image178x100',
    associationType: 'ImageMedia178X100',
    width: 1080,
    height: 1080,
    cropSettings: {
      SourceWidth: 1080, SourceHeight: 607, SourceX: 0, SourceY: 237,
    },
    isIncluded: false,
    isLogo: false,
    isRecommendedImage: false,
    originCropSetting: {
      SourceWidth: 1080, SourceHeight: 607, SourceX: 0, SourceY: 237,
    },
    isAutoCropping: true,
    baseImage: {
      id: '7146826138370', idString: '7146826138370', src: 'https://www.bing-exp.com/th?id=OADD2.7146826138370_17CZ8MCZKY4MKLZWVI&pid=21.2', type: null, associationType: 'ImageMedia178X100', width: 1080, height: 1080, cropSettings: null, effectSettings: null, baseId: null, metadata: null, isIncluded: false, isLogo: false, isRecommendedImage: false, originCropSetting: null,
    },
  }, {
    id: '7146826138370',
    idString: '7146826138370',
    src: 'https://www.bing-exp.com/th?id=OADD2.7146826138370_17CZ8MCZKY4MKLZWVI&pid=21.2',
    type: 'Image150x100',
    associationType: 'ImageMedia15X10',
    width: 1080,
    height: 1080,
    cropSettings: {
      SourceWidth: 1080, SourceHeight: 720, SourceX: 0, SourceY: 180,
    },
    isIncluded: false,
    isLogo: false,
    isRecommendedImage: false,
    originCropSetting: {
      SourceWidth: 1080, SourceHeight: 720, SourceX: 0, SourceY: 180,
    },
    isAutoCropping: true,
    baseImage: {
      id: '7146826138370', idString: '7146826138370', src: 'https://www.bing-exp.com/th?id=OADD2.7146826138370_17CZ8MCZKY4MKLZWVI&pid=21.2', type: null, associationType: 'ImageMedia15X10', width: 1080, height: 1080, cropSettings: null, effectSettings: null, baseId: null, metadata: null, isIncluded: false, isLogo: false, isRecommendedImage: false, originCropSetting: null,
    },
  }, {
    id: '7146826138370',
    idString: '7146826138370',
    src: 'https://www.bing-exp.com/th?id=OADD2.7146826138370_17CZ8MCZKY4MKLZWVI&pid=21.2',
    type: 'Image133x100',
    associationType: 'ImageMedia133X100',
    width: 1080,
    height: 1080,
    cropSettings: {
      SourceWidth: 1080, SourceHeight: 812, SourceX: 0, SourceY: 134,
    },
    isIncluded: false,
    isLogo: false,
    isRecommendedImage: false,
    originCropSetting: {
      SourceWidth: 1080, SourceHeight: 812, SourceX: 0, SourceY: 134,
    },
    isAutoCropping: true,
    baseImage: {
      id: '7146826138370', idString: '7146826138370', src: 'https://www.bing-exp.com/th?id=OADD2.7146826138370_17CZ8MCZKY4MKLZWVI&pid=21.2', type: null, associationType: 'ImageMedia133X100', width: 1080, height: 1080, cropSettings: null, effectSettings: null, baseId: null, metadata: null, isIncluded: false, isLogo: false, isRecommendedImage: false, originCropSetting: null,
    },
  }, {
    id: '7146826138370',
    idString: '7146826138370',
    src: 'https://www.bing-exp.com/th?id=OADD2.7146826138370_17CZ8MCZKY4MKLZWVI&pid=21.2',
    type: 'Image1x1',
    associationType: 'SquareImageMedia',
    width: 1080,
    height: 1080,
    cropSettings: {
      SourceWidth: 1080, SourceHeight: 1080, SourceX: 0, SourceY: 0,
    },
    isIncluded: false,
    isLogo: false,
    isRecommendedImage: false,
    originCropSetting: {
      SourceWidth: 1080, SourceHeight: 1080, SourceX: 0, SourceY: 0,
    },
    isAutoCropping: true,
    baseImage: {
      id: '7146826138370', idString: '7146826138370', src: 'https://www.bing-exp.com/th?id=OADD2.7146826138370_17CZ8MCZKY4MKLZWVI&pid=21.2', type: null, associationType: 'SquareImageMedia', width: 1080, height: 1080, cropSettings: null, effectSettings: null, baseId: null, metadata: null, isIncluded: true, isLogo: false, isRecommendedImage: false, originCropSetting: null,
    },
  }], [{
    id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1xZL420knQHMs_-TvANTgp33NWP_XeKZI.jpg',
    idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1xZL420knQHMs_-TvANTgp33NWP_XeKZI.jpg',
    src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1xZL420knQHMs_-TvANTgp33NWP_XeKZI.jpg',
    type: 'Image191x100',
    width: 1080,
    height: 1080,
    cropSettings: {
      SourceX: 0, SourceY: 258, SourceWidth: 1080, SourceHeight: 565,
    },
    isIncluded: true,
    isLogo: false,
    isRecommendedImage: true,
    originCropSetting: {
      SourceWidth: 1080, SourceHeight: 565, SourceX: 0, SourceY: 258,
    },
    baseImage: {
      id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1xZL420knQHMs_-TvANTgp33NWP_XeKZI.jpg',
      idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1xZL420knQHMs_-TvANTgp33NWP_XeKZI.jpg',
      src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1xZL420knQHMs_-TvANTgp33NWP_XeKZI.jpg',
      type: null,
      width: 1080,
      height: 1080,
      cropSettings: null,
      effectSettings: null,
      baseId: null,
      metadata: null,
      isIncluded: true,
      isLogo: false,
      isRecommendedImage: true,
      originCropSetting: {
        SourceWidth: 1080, SourceHeight: 565, SourceX: 0, SourceY: 258,
      },
    },
  }, {
    id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1xZL420knQHMs_-TvANTgp33NWP_XeKZI.jpg',
    idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1xZL420knQHMs_-TvANTgp33NWP_XeKZI.jpg',
    src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1xZL420knQHMs_-TvANTgp33NWP_XeKZI.jpg',
    type: 'Image178x100',
    associationType: 'ImageMedia178X100',
    width: 1080,
    height: 1080,
    cropSettings: {
      SourceWidth: 1080, SourceHeight: 607, SourceX: 0, SourceY: 237,
    },
    isIncluded: true,
    isLogo: false,
    isRecommendedImage: false,
    originCropSetting: {
      SourceWidth: 1080, SourceHeight: 607, SourceX: 0, SourceY: 237,
    },
    isAutoCropping: true,
    baseImage: {
      id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1xZL420knQHMs_-TvANTgp33NWP_XeKZI.jpg', idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1xZL420knQHMs_-TvANTgp33NWP_XeKZI.jpg', src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1xZL420knQHMs_-TvANTgp33NWP_XeKZI.jpg', type: null, associationType: 'ImageMedia178X100', width: 1080, height: 1080, cropSettings: null, effectSettings: null, baseId: null, metadata: null, isIncluded: false, isLogo: false, isRecommendedImage: false, originCropSetting: null,
    },
  }, {
    id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1xZL420knQHMs_-TvANTgp33NWP_XeKZI.jpg',
    idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1xZL420knQHMs_-TvANTgp33NWP_XeKZI.jpg',
    src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1xZL420knQHMs_-TvANTgp33NWP_XeKZI.jpg',
    type: 'Image150x100',
    associationType: 'ImageMedia15X10',
    width: 1080,
    height: 1080,
    cropSettings: {
      SourceWidth: 1080, SourceHeight: 720, SourceX: 0, SourceY: 180,
    },
    isIncluded: true,
    isLogo: false,
    isRecommendedImage: false,
    originCropSetting: {
      SourceWidth: 1080, SourceHeight: 720, SourceX: 0, SourceY: 180,
    },
    isAutoCropping: true,
    baseImage: {
      id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1xZL420knQHMs_-TvANTgp33NWP_XeKZI.jpg', idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1xZL420knQHMs_-TvANTgp33NWP_XeKZI.jpg', src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1xZL420knQHMs_-TvANTgp33NWP_XeKZI.jpg', type: null, associationType: 'ImageMedia15X10', width: 1080, height: 1080, cropSettings: null, effectSettings: null, baseId: null, metadata: null, isIncluded: false, isLogo: false, isRecommendedImage: false, originCropSetting: null,
    },
  }, {
    id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1xZL420knQHMs_-TvANTgp33NWP_XeKZI.jpg',
    idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1xZL420knQHMs_-TvANTgp33NWP_XeKZI.jpg',
    src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1xZL420knQHMs_-TvANTgp33NWP_XeKZI.jpg',
    type: 'Image133x100',
    associationType: 'ImageMedia133X100',
    width: 1080,
    height: 1080,
    cropSettings: {
      SourceWidth: 1080, SourceHeight: 812, SourceX: 0, SourceY: 134,
    },
    isIncluded: true,
    isLogo: false,
    isRecommendedImage: false,
    originCropSetting: {
      SourceWidth: 1080, SourceHeight: 812, SourceX: 0, SourceY: 134,
    },
    isAutoCropping: true,
    baseImage: {
      id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1xZL420knQHMs_-TvANTgp33NWP_XeKZI.jpg', idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1xZL420knQHMs_-TvANTgp33NWP_XeKZI.jpg', src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1xZL420knQHMs_-TvANTgp33NWP_XeKZI.jpg', type: null, associationType: 'ImageMedia133X100', width: 1080, height: 1080, cropSettings: null, effectSettings: null, baseId: null, metadata: null, isIncluded: false, isLogo: false, isRecommendedImage: false, originCropSetting: null,
    },
  }, {
    id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1xZL420knQHMs_-TvANTgp33NWP_XeKZI.jpg',
    idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1xZL420knQHMs_-TvANTgp33NWP_XeKZI.jpg',
    src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1xZL420knQHMs_-TvANTgp33NWP_XeKZI.jpg',
    type: 'Image1x1',
    associationType: 'SquareImageMedia',
    width: 1080,
    height: 1080,
    cropSettings: {
      SourceWidth: 1080, SourceHeight: 1080, SourceX: 0, SourceY: 0,
    },
    isIncluded: true,
    isLogo: false,
    isRecommendedImage: false,
    originCropSetting: {
      SourceWidth: 1080, SourceHeight: 1080, SourceX: 0, SourceY: 0,
    },
    isAutoCropping: true,
    baseImage: {
      id: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1xZL420knQHMs_-TvANTgp33NWP_XeKZI.jpg', idString: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1xZL420knQHMs_-TvANTgp33NWP_XeKZI.jpg', src: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1xZL420knQHMs_-TvANTgp33NWP_XeKZI.jpg', type: null, associationType: 'SquareImageMedia', width: 1080, height: 1080, cropSettings: null, effectSettings: null, baseId: null, metadata: null, isIncluded: true, isLogo: false, isRecommendedImage: false, originCropSetting: null,
    },
  }], [{
    id: 'https://blogs.bing.com/BingBlogs/files/b6/b6b1efa2-e24a-447d-8ec2-076a9ba7c4f2.jpg',
    idString: 'https://blogs.bing.com/BingBlogs/files/b6/b6b1efa2-e24a-447d-8ec2-076a9ba7c4f2.jpg',
    src: 'https://blogs.bing.com/BingBlogs/files/b6/b6b1efa2-e24a-447d-8ec2-076a9ba7c4f2.jpg',
    type: 'Image191x100',
    width: 1920,
    height: 812,
    cropSettings: {
      SourceX: 185, SourceY: 0, SourceWidth: 1551, SourceHeight: 812,
    },
    isIncluded: true,
    isLogo: false,
    isRecommendedImage: true,
    originCropSetting: {
      SourceWidth: 1551, SourceHeight: 812, SourceX: 185, SourceY: 0,
    },
    baseImage: {
      id: 'https://blogs.bing.com/BingBlogs/files/b6/b6b1efa2-e24a-447d-8ec2-076a9ba7c4f2.jpg',
      idString: 'https://blogs.bing.com/BingBlogs/files/b6/b6b1efa2-e24a-447d-8ec2-076a9ba7c4f2.jpg',
      src: 'https://blogs.bing.com/BingBlogs/files/b6/b6b1efa2-e24a-447d-8ec2-076a9ba7c4f2.jpg',
      type: null,
      width: 1920,
      height: 812,
      cropSettings: null,
      effectSettings: null,
      baseId: null,
      metadata: null,
      isIncluded: true,
      isLogo: false,
      isRecommendedImage: true,
      originCropSetting: {
        SourceWidth: 1551, SourceHeight: 812, SourceX: 185, SourceY: 0,
      },
    },
  }, {
    id: 'https://blogs.bing.com/BingBlogs/files/b6/b6b1efa2-e24a-447d-8ec2-076a9ba7c4f2.jpg',
    idString: 'https://blogs.bing.com/BingBlogs/files/b6/b6b1efa2-e24a-447d-8ec2-076a9ba7c4f2.jpg',
    src: 'https://blogs.bing.com/BingBlogs/files/b6/b6b1efa2-e24a-447d-8ec2-076a9ba7c4f2.jpg',
    type: 'Image178x100',
    associationType: 'ImageMedia178X100',
    width: 1920,
    height: 812,
    cropSettings: {
      SourceWidth: 1445, SourceHeight: 812, SourceX: 238, SourceY: 0,
    },
    isIncluded: true,
    isLogo: false,
    isRecommendedImage: false,
    originCropSetting: {
      SourceWidth: 1445, SourceHeight: 812, SourceX: 238, SourceY: 0,
    },
    isAutoCropping: true,
    baseImage: {
      id: 'https://blogs.bing.com/BingBlogs/files/b6/b6b1efa2-e24a-447d-8ec2-076a9ba7c4f2.jpg', idString: 'https://blogs.bing.com/BingBlogs/files/b6/b6b1efa2-e24a-447d-8ec2-076a9ba7c4f2.jpg', src: 'https://blogs.bing.com/BingBlogs/files/b6/b6b1efa2-e24a-447d-8ec2-076a9ba7c4f2.jpg', type: null, associationType: 'ImageMedia178X100', width: 1920, height: 812, cropSettings: null, effectSettings: null, baseId: null, metadata: null, isIncluded: false, isLogo: false, isRecommendedImage: false, originCropSetting: null,
    },
  }, {
    id: 'https://blogs.bing.com/BingBlogs/files/b6/b6b1efa2-e24a-447d-8ec2-076a9ba7c4f2.jpg',
    idString: 'https://blogs.bing.com/BingBlogs/files/b6/b6b1efa2-e24a-447d-8ec2-076a9ba7c4f2.jpg',
    src: 'https://blogs.bing.com/BingBlogs/files/b6/b6b1efa2-e24a-447d-8ec2-076a9ba7c4f2.jpg',
    type: 'Image150x100',
    associationType: 'ImageMedia15X10',
    width: 1920,
    height: 812,
    cropSettings: {
      SourceWidth: 1218, SourceHeight: 812, SourceX: 351, SourceY: 0,
    },
    isIncluded: true,
    isLogo: false,
    isRecommendedImage: false,
    originCropSetting: {
      SourceWidth: 1218, SourceHeight: 812, SourceX: 351, SourceY: 0,
    },
    isAutoCropping: true,
    baseImage: {
      id: 'https://blogs.bing.com/BingBlogs/files/b6/b6b1efa2-e24a-447d-8ec2-076a9ba7c4f2.jpg', idString: 'https://blogs.bing.com/BingBlogs/files/b6/b6b1efa2-e24a-447d-8ec2-076a9ba7c4f2.jpg', src: 'https://blogs.bing.com/BingBlogs/files/b6/b6b1efa2-e24a-447d-8ec2-076a9ba7c4f2.jpg', type: null, associationType: 'ImageMedia15X10', width: 1920, height: 812, cropSettings: null, effectSettings: null, baseId: null, metadata: null, isIncluded: false, isLogo: false, isRecommendedImage: false, originCropSetting: null,
    },
  }, {
    id: 'https://blogs.bing.com/BingBlogs/files/b6/b6b1efa2-e24a-447d-8ec2-076a9ba7c4f2.jpg',
    idString: 'https://blogs.bing.com/BingBlogs/files/b6/b6b1efa2-e24a-447d-8ec2-076a9ba7c4f2.jpg',
    src: 'https://blogs.bing.com/BingBlogs/files/b6/b6b1efa2-e24a-447d-8ec2-076a9ba7c4f2.jpg',
    type: 'Image133x100',
    associationType: 'ImageMedia133X100',
    width: 1920,
    height: 812,
    cropSettings: {
      SourceWidth: 1080, SourceHeight: 812, SourceX: 420, SourceY: 0,
    },
    isIncluded: true,
    isLogo: false,
    isRecommendedImage: false,
    originCropSetting: {
      SourceWidth: 1080, SourceHeight: 812, SourceX: 420, SourceY: 0,
    },
    isAutoCropping: true,
    baseImage: {
      id: 'https://blogs.bing.com/BingBlogs/files/b6/b6b1efa2-e24a-447d-8ec2-076a9ba7c4f2.jpg', idString: 'https://blogs.bing.com/BingBlogs/files/b6/b6b1efa2-e24a-447d-8ec2-076a9ba7c4f2.jpg', src: 'https://blogs.bing.com/BingBlogs/files/b6/b6b1efa2-e24a-447d-8ec2-076a9ba7c4f2.jpg', type: null, associationType: 'ImageMedia133X100', width: 1920, height: 812, cropSettings: null, effectSettings: null, baseId: null, metadata: null, isIncluded: false, isLogo: false, isRecommendedImage: false, originCropSetting: null,
    },
  }, {
    id: 'https://blogs.bing.com/BingBlogs/files/b6/b6b1efa2-e24a-447d-8ec2-076a9ba7c4f2.jpg',
    idString: 'https://blogs.bing.com/BingBlogs/files/b6/b6b1efa2-e24a-447d-8ec2-076a9ba7c4f2.jpg',
    src: 'https://blogs.bing.com/BingBlogs/files/b6/b6b1efa2-e24a-447d-8ec2-076a9ba7c4f2.jpg',
    type: 'Image1x1',
    associationType: 'SquareImageMedia',
    width: 1920,
    height: 812,
    cropSettings: {
      SourceWidth: 812, SourceHeight: 812, SourceX: 554, SourceY: 0,
    },
    isIncluded: true,
    isLogo: false,
    isRecommendedImage: false,
    originCropSetting: {
      SourceWidth: 812, SourceHeight: 812, SourceX: 554, SourceY: 0,
    },
    isAutoCropping: true,
    baseImage: {
      id: 'https://blogs.bing.com/BingBlogs/files/b6/b6b1efa2-e24a-447d-8ec2-076a9ba7c4f2.jpg', idString: 'https://blogs.bing.com/BingBlogs/files/b6/b6b1efa2-e24a-447d-8ec2-076a9ba7c4f2.jpg', src: 'https://blogs.bing.com/BingBlogs/files/b6/b6b1efa2-e24a-447d-8ec2-076a9ba7c4f2.jpg', type: null, associationType: 'SquareImageMedia', width: 1920, height: 812, cropSettings: null, effectSettings: null, baseId: null, metadata: null, isIncluded: false, isLogo: false, isRecommendedImage: false, originCropSetting: null,
    },
  }]],
  shortHeadline: 'Bing Images Search',
  longHeadline: 'Turn information into action. Make it faster & easier to go from Browsing to doing Things.',
  description: 'Turn information into action. Make it faster & easier to go from Browsing to doing Things.',
  businessName: 'Bing',
  url: 'https://bing.com',
}];


export const ads = [{
  '@odata.type': '#Model.ResponsiveAd',
  Text: 'Make it faster and easier to go from Browsing to doing Things Online.',
  FinalUrls: ['https://bing.com'],
  Headline: 'Maps Bing Maps',
  LongHeadline: 'Make it faster and easier to go from Browsing to doing Things Online.',
  BusinessName: 'Bing',
  Images: [{
    Id: '',
    PinnedField: 'None',
    EditorialStatus: null,
    AssociationType: 'None',
    UiDisplayStatus: 'Inactive',
    PerformanceLabel: null,
    RecommendationId: null,
    Asset: {
      '@odata.type': '#Model.ImageAsset', Id: 0, Name: null, AssetType: 'Empty', Text: null, TracingId: null, SubType: 'None', IdString: '0', CropX: 0, CropY: 0, CropHeight: 1080, CropWidth: 1080, ImageUrl: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg',
    },
    PerformanceMetrics: null,
  }, {
    Id: '',
    PinnedField: 'None',
    EditorialStatus: null,
    AssociationType: 'None',
    UiDisplayStatus: 'Inactive',
    PerformanceLabel: null,
    RecommendationId: null,
    Asset: {
      '@odata.type': '#Model.ImageAsset', Id: 0, Name: null, AssetType: 'Empty', Text: null, TracingId: null, SubType: 'None', IdString: '0', CropX: 0, CropY: 0, CropHeight: 1080, CropWidth: 1080, ImageUrl: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg',
    },
    PerformanceMetrics: null,
  }, {
    Id: '',
    PinnedField: 'None',
    EditorialStatus: null,
    AssociationType: 'None',
    UiDisplayStatus: 'Inactive',
    PerformanceLabel: null,
    RecommendationId: null,
    Asset: {
      '@odata.type': '#Model.ImageAsset', Id: 0, Name: null, AssetType: 'Empty', Text: null, TracingId: null, SubType: 'None', IdString: '0', CropX: 0, CropY: 0, CropHeight: 1290, CropWidth: 2400, ImageUrl: 'https://blogs.bing.com/BingBlogs/files/50/50be2ce8-de70-4b33-8aa6-43abf774d114.png',
    },
    PerformanceMetrics: null,
  }],
  Headlines: [{
    Id: '',
    PinnedField: 'None',
    EditorialStatus: null,
    AssociationType: 'None',
    UiDisplayStatus: 'Inactive',
    PerformanceLabel: null,
    RecommendationId: null,
    Asset: {
      '@odata.type': '#Model.TextAsset', Id: 0, Name: null, AssetType: 'Text', Text: 'Maps Bing Maps', TracingId: null,
    },
    PerformanceMetrics: null,
  }],
  LongHeadlines: [{
    Id: '',
    PinnedField: 'None',
    EditorialStatus: null,
    AssociationType: 'None',
    UiDisplayStatus: 'Inactive',
    PerformanceLabel: null,
    RecommendationId: null,
    Asset: {
      '@odata.type': '#Model.TextAsset', Id: 0, Name: null, AssetType: 'Text', Text: 'Make it faster and easier to go from Browsing to doing Things Online.', TracingId: null,
    },
    PerformanceMetrics: null,
  }, {
    Id: '',
    PinnedField: 'None',
    EditorialStatus: null,
    AssociationType: 'None',
    UiDisplayStatus: 'Inactive',
    PerformanceLabel: null,
    RecommendationId: null,
    Asset: {
      '@odata.type': '#Model.TextAsset', Id: 0, Name: null, AssetType: 'Text', Text: 'Bing helps you turn information into action, making it faster & easier to go from Browsing', TracingId: null,
    },
    PerformanceMetrics: null,
  }],
  Descriptions: [{
    Id: '',
    PinnedField: 'None',
    EditorialStatus: null,
    AssociationType: 'None',
    UiDisplayStatus: 'Inactive',
    PerformanceLabel: null,
    RecommendationId: null,
    Asset: {
      '@odata.type': '#Model.TextAsset', Id: 0, Name: null, AssetType: 'Text', Text: 'Make it faster and easier to go from Browsing to doing Things Online.', TracingId: null,
    },
    PerformanceMetrics: null,
  }, {
    Id: '',
    PinnedField: 'None',
    EditorialStatus: null,
    AssociationType: 'None',
    UiDisplayStatus: 'Inactive',
    PerformanceLabel: null,
    RecommendationId: null,
    Asset: {
      '@odata.type': '#Model.TextAsset', Id: 0, Name: null, AssetType: 'Text', Text: 'Bing helps you turn information into action, making it faster & easier to go from Browsing', TracingId: null,
    },
    PerformanceMetrics: null,
  }],
}, {
  '@odata.type': '#Model.ResponsiveAd',
  Text: 'Make it faster and easier to go from Browsing to doing the Things you Love.',
  FinalUrls: ['https://bing.com'],
  Headline: 'Bing Photo Search',
  LongHeadline: 'Make it faster and easier to go from Browsing to doing the Things you Love.',
  BusinessName: 'Bing',
  Images: [{
    Id: '',
    PinnedField: 'None',
    EditorialStatus: null,
    AssociationType: 'None',
    UiDisplayStatus: 'Inactive',
    PerformanceLabel: null,
    RecommendationId: null,
    Asset: {
      '@odata.type': '#Model.ImageAsset', Id: 0, Name: null, AssetType: 'Empty', Text: null, TracingId: null, SubType: 'None', IdString: '0', CropX: 0, CropY: 0, CropHeight: 1080, CropWidth: 1080, ImageUrl: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1-HWpcPamxFHV1xYBSKHbKKD-kCAwRAi1.jpg',
    },
    PerformanceMetrics: null,
  }, {
    Id: '',
    PinnedField: 'None',
    EditorialStatus: null,
    AssociationType: 'None',
    UiDisplayStatus: 'Inactive',
    PerformanceLabel: null,
    RecommendationId: null,
    Asset: {
      '@odata.type': '#Model.ImageAsset', Id: 0, Name: null, AssetType: 'Empty', Text: null, TracingId: null, SubType: 'None', IdString: '0', CropX: 0, CropY: 0, CropHeight: 1080, CropWidth: 1080, ImageUrl: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/16KVMOQPeJU2laynni3k-c6CORdmpobSZ.jpg',
    },
    PerformanceMetrics: null,
  }, {
    Id: '',
    PinnedField: 'None',
    EditorialStatus: null,
    AssociationType: 'None',
    UiDisplayStatus: 'Inactive',
    PerformanceLabel: null,
    RecommendationId: null,
    Asset: {
      '@odata.type': '#Model.ImageAsset', Id: 0, Name: null, AssetType: 'Empty', Text: null, TracingId: null, SubType: 'None', IdString: '0', CropX: 0, CropY: 0, CropHeight: 1080, CropWidth: 1080, ImageUrl: 'https://aggsvcstorage.z13.web.core.windows.net/stock-images/1A9HiRm2AhPL6u0sgct0ku6nxDSPoHZhb.jpg',
    },
    PerformanceMetrics: null,
  }],
  Headlines: [{
    Id: '',
    PinnedField: 'None',
    EditorialStatus: null,
    AssociationType: 'None',
    UiDisplayStatus: 'Inactive',
    PerformanceLabel: null,
    RecommendationId: null,
    Asset: {
      '@odata.type': '#Model.TextAsset', Id: 0, Name: null, AssetType: 'Text', Text: 'Bing Photo Search', TracingId: null,
    },
    PerformanceMetrics: null,
  }],
  LongHeadlines: [{
    Id: '',
    PinnedField: 'None',
    EditorialStatus: null,
    AssociationType: 'None',
    UiDisplayStatus: 'Inactive',
    PerformanceLabel: null,
    RecommendationId: null,
    Asset: {
      '@odata.type': '#Model.TextAsset', Id: 0, Name: null, AssetType: 'Text', Text: 'Make it faster and easier to go from Browsing to doing the Things you Love.', TracingId: null,
    },
    PerformanceMetrics: null,
  }, {
    Id: '',
    PinnedField: 'None',
    EditorialStatus: null,
    AssociationType: 'None',
    UiDisplayStatus: 'Inactive',
    PerformanceLabel: null,
    RecommendationId: null,
    Asset: {
      '@odata.type': '#Model.TextAsset', Id: 0, Name: null, AssetType: 'Text', Text: 'Turn information into action, making it faster and easier to go from Browsing to doing.', TracingId: null,
    },
    PerformanceMetrics: null,
  }],
  Descriptions: [{
    Id: '',
    PinnedField: 'None',
    EditorialStatus: null,
    AssociationType: 'None',
    UiDisplayStatus: 'Inactive',
    PerformanceLabel: null,
    RecommendationId: null,
    Asset: {
      '@odata.type': '#Model.TextAsset', Id: 0, Name: null, AssetType: 'Text', Text: 'Make it faster and easier to go from Browsing to doing the Things you Love.', TracingId: null,
    },
    PerformanceMetrics: null,
  }, {
    Id: '',
    PinnedField: 'None',
    EditorialStatus: null,
    AssociationType: 'None',
    UiDisplayStatus: 'Inactive',
    PerformanceLabel: null,
    RecommendationId: null,
    Asset: {
      '@odata.type': '#Model.TextAsset', Id: 0, Name: null, AssetType: 'Text', Text: 'Turn information into action, making it faster and easier to go from Browsing to doing.', TracingId: null,
    },
    PerformanceMetrics: null,
  }],
}];
